export default __webpack_public_path__ + "static/SigCap-7994b64814383e72b54f0589da1bd64d.png";